import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';

import '@/assets/styles.scss';
import Aura from '@primeuix/themes/aura';
import { Form } from '@primevue/forms';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

// Import PrimeVue components to register globally
import DatePicker from '@/components/DatePicker.vue';
import { currencyFormatter } from '@/utils/currency';
import 'primeicons/primeicons.css';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import RadioButton from 'primevue/radiobutton';
import TabPanel from 'primevue/tabpanel';
import TabView from 'primevue/tabview';
import Textarea from 'primevue/textarea';
import stores from './stores';
const globalOptions = {
  mode: 'auto',
};

const app = createApp(App);
app.use(VueTelInput, globalOptions);
app.use(router);
app.use(stores);

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.app-dark',
    },
  },
});
app.use(ToastService);
app.use(ConfirmationService);

// Register PrimeVue components globally
app.component('Card', Card);
// eslint-disable-next-line vue/no-reserved-component-names
app.component('Form', Form);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('InputText', InputText);
// eslint-disable-next-line vue/no-reserved-component-names
app.component('Textarea', Textarea);
app.component('InputNumber', InputNumber);
app.component('Dropdown', Dropdown);
app.component('Checkbox', Checkbox);
app.component('RadioButton', RadioButton);
app.component('Divider', Divider);
app.component('DatePicker', DatePicker);
app.config.globalProperties.$currency = currencyFormatter;

app.mount('#app');
